import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { ssoLogin, exchangeToken } from "../../actions/authActions"
import { Redirect } from "react-router-dom"
import { Grid, CircularProgress } from "@material-ui/core"
import * as userInfoActions from "../../actions/userInfoActions"
import * as locationsActions from "../../actions/locationsActions"
import * as bookingsActions from "../../actions/bookingsActions"
import { useAuth } from "react-oidc-context";
import _ from "lodash"
import PropTypes from "prop-types"

const SsoAuth = (props) => {
  const dispatch = useDispatch()
  const base = location.pathname.split("/")[1].toUpperCase()
  const ssoAuth = useAuth();
  const auth = useSelector(state => state.auth)
  const userInfo = useSelector((state) => ({ ...state.userInfo }))
  const locations = useSelector((state) => ({ ...state.locations }))
  const bookings = useSelector((state) => ({ ...state.bookings }))
  const serviceName = _.get(_.find(userInfo.settings.meta, { "key": "serviceName" }), "value", "");

  useEffect(() => {
    if (!_.isEmpty(ssoAuth.user?.access_token)) {
      dispatch(ssoLogin(ssoAuth.user?.access_token, Date.now()))
    }
  }, [ssoAuth])

  useEffect(() => {
    const shouldSendExchange = !_.isEmpty(auth.ssoToken) && _.isEmpty(auth.token)
    if (shouldSendExchange) {
      dispatch(exchangeToken(auth.ssoToken, base))
    }
  }, [auth.ssoToken, auth.token])
  useEffect(() => {
    // These three actions are required for the next page.
    if (auth.token != "" && auth.error == "") {
      dispatch(bookingsActions.getVehicleModels({ token: auth.token }))
      dispatch(locationsActions.getAllLocations({ token: auth.token }))
      // dispatch(userInfoActions.getUserSettings({ token: auth.token }))
      dispatch(userInfoActions.getServiceSettings({ token: auth.token }))
    }
  }, [auth.token])

  const isDependenciesLoaded = () => {
    return (
      (serviceName != "" &&
        locations.locations != null &&
        bookings.vehicles.length != 0) ||
      auth.token == ""
    )
  }

  let { from } = props.location.state || { from: { pathname: `/${base}` } }

  from =
    from.pathname != "/" && from.pathname != "/login"
      ? from
      : serviceName != "" && ssoAuth.user?.access_token != ""
        ? { pathname: `/${base}/dashboard` }
        : { from: { pathname: "/" } }


  /* useEffect(() => {
    if (!loaded) {
      const token = JSON.parse(atob(location.search.replace("?auth_string=", "")))
      dispatch(ssoLogin(token.token, token.expiry))
      dispatch(userInfoActions.getUserSettings({ token: token.token }))
      setLoaded(true)
    }
  }, [])

  useEffect(() => {
    console.log(stateToken)
    if (stateToken && user) {
      window.location.replace(`${window.location.origin}/${base}`)
    }
  }, [stateToken, user]) */
  return (isDependenciesLoaded() && auth.token != "" && from.pathname != "/" ? (
    <Redirect to={from} />
  ) : <Grid container direction="row" justifyContent="center" alignItems="center" style={{ minHeight: 500 }}>
      <Grid item xs={12} style={{ textAlign: "center", marginTop: 5 }}>
        <CircularProgress size={50} thickness={4} />
        <h4 style={{ marginBottom: 5 }}>Fetching your settings and logging you in...</h4>* If you&apos;re not redirected within 30 seconds please
        click&nbsp;
      </Grid>
    </Grid>
  )
}

SsoAuth.propTypes = {
  location: {
    state: PropTypes.string
  }
}

export default SsoAuth

